<template >
  <base-material-card color="secondary" class="mx-10" icon="mdi-calendar-multiple-check">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">{{ $t('list_contab_reg') }}</div>
    </template>
    <v-layout class="mx-0 mx-sm-10">
      <v-tabs v-if="!$vuetify.breakpoint.smAndDown" v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_stats') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_registration') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_cdx') }}
        </v-tab> <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('monthly_balances') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_nota') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_rendiconto') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-cube-scan</v-icon>
          {{ $t('upload_invoice') }}
        </v-tab>
      </v-tabs>
      <div v-else class="mobileTabsMenu">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" block v-bind="attrs" v-on="on">
              <v-icon left>{{ mobileTabs[tabs] ? mobileTabs[tabs].icon : 'mdi-book-open-outline' }}</v-icon>
              {{ mobileTabs[tabs] ? mobileTabs[tabs].label : $t('list_contab_reg') }}
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in mobileTabs" :key="index" @click="tabs = index">
              <v-icon class="mr-2">{{ item.icon }}</v-icon>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-layout>

    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item>
        <statistiche-cge></statistiche-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="M"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="C"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="S"></list-cge>
      </v-tab-item><v-tab-item>
        <list-cge type="N"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <rendiconto-cge></rendiconto-cge>
      </v-tab-item>
      <v-tab-item>
        <upload-fattura></upload-fattura>
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import listMovimenti from "@/app/contab/listMovimenti.vue";
import rendiconto from "@/app/contab/rendiconto.vue";
import statistiche from "@/app/contab/statistiche.vue";
import uploadFattura from "@/app/contab/uploadFattura.vue";

export default {
  name: "dashboard-contabile",
  components: {
    "list-cge": listMovimenti,
    "rendiconto-cge": rendiconto,
    "statistiche-cge": statistiche,
    "upload-fattura": uploadFattura
  },
  data() {
    return {
      tabs: 0
    };
  },
  methods: {},
  computed: {
    mobileTabs() {
      return [
        { icon: "mdi-book-open-outline", label: this.$t("reg_title_stats") },
        { icon: "mdi-book-open-outline", label: this.$t("reg_title_registration") },
        { icon: "mdi-book-open-outline", label: this.$t("reg_title_cdx") },
        { icon: "mdi-book-open-outline", label: this.$t("monthly_balances") },
        { icon: "mdi-book-open-outline", label: this.$t("reg_title_nota") },
        { icon: "mdi-book-open-outline", label: this.$t("reg_title_rendiconto") },
        { icon: "mdi-cube-scan", label: this.$t("upload_invoice") },
      ];
    },
  },
  created() {
    this.tabs = parseInt(this.$route.query.tab, 10) || 0;
  },
  watch: {
    tabs(value) {
      // mantiene la tab corrente nell'URL per sopravvivere al reload della pagina
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  }
};
</script>
<style>
.mobileTabsMenu {
  width: 100%;
  margin-bottom: 12px;
}
.mobileTabsMenu .v-menu {
  display: block;
  width: 100%;
}
</style>
